import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/active/all`;

export const ROUTE: RouteDefinition = `${baseRoute}/active/all`;

export const URL = (): RouteDefinition => `${baseRoute}/active/all`;
